import { ReactElement } from "react";

import VippsButton from "./vippsPaymentButton.svg?react";

export default function VippsPaymentButton(): ReactElement {
    return <VippsButton />;
}
